import { createKairosApp } from '@/app/createApp';

import '@/assets/css/nerdfonts-symbols.css';

createKairosApp().mount('#app');
